const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过十万部电影资源，涵盖全球各类题材，从商业巨制到独立佳作，新片老片应有尽有。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站采用高清蓝光片源，画质清晰细腻。支持多种分辨率自适应，根据网速智能切换最佳画质。',
  },
  {
    icon: 'ri-speed-line',
    title: '流畅播放',
    desc: '先进的CDN加速技术覆盖全国节点，无论身处何地都能享受低延迟、不卡顿的流畅观影体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '片库保持每日更新频率，新片上映后第一时间上线。同时持续扩充经典影片资源，片库不断增长。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          核心优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          为什么选择97影院？四个理由告诉你
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}